const VERSION = "0.9.2";

export default VERSION;
